<template>
  <div class="m_m_payee_list">
    <div class="table_btm">
      <el-button class="add_btn border_set_color" icon="el-icon-plus" @click="add_btn">{{$t('main.text377')}}</el-button>
    </div>

      <div class="list_title1">{{$t('main.text378')}}</div>
      <table class="list_table">
          <div v-for="(item,index) in tableData" :key="index">
              <!-- <td>
                  <el-checkbox-group v-model="checkList" @change="checkbox_fun(index)">
                    <el-checkbox>Christoffer Mila</el-checkbox>
                </el-checkbox-group>
              </td> -->
              <div class="td1">{{item.beneficiary_name}}</div>
              <div class="td2">{{item.name}}</div>
              <div class="td3">{{item.account_number}}</div>
              <div class="text_r td4">
                  <span class="edit_btn" @click="edit_fun(item)">{{$t('main.text71')}}</span>
                  <span class="delete_btn" @click="delete_fun(item)">{{$t('main.text363')}}</span>
              </div>
          </div>
          <span v-if="page_total<=0" class="no_data_text">{{$t('main.text364')}}</span>
      </table>
      <el-pagination
      v-if="tableData.length > 0"
      background
      :page-sizes="[10, 20, 30, 40]"
      :page-size="limit"
      :current-page.sync="currentPage"
      layout="prev, pager, next"
      :total="page_total"
      @current-change="current_change"
      ></el-pagination>

    <!-- 添加 -->
    <el-dialog
      :title="$t('main.text377')"
      :visible.sync="add_user_dlg"
      custom-class="dlg element_input dlg_height add_dlg"
      append-to-body
      center
      width="640px"
    >
      <div class="dlg_body border_bottom">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{$t('main.text351')}}</div>
            <el-form-item :label="$t('main.text352')">
              <el-input v-model="add_form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text280')">
              <el-input v-model="add_form.account_number" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text348')">
              <el-input v-model="add_form.beneficiary_name" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text353')">
              <el-input v-model="add_form.swift_code" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text277')">
              <el-input v-model="add_form.address" type="text"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{$t('main.text354')}}</div>
            <el-form-item :label="$t('main.text355')">
              <el-input v-model="add_form.intermediary_name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text356')">
              <el-select filterable v-model="add_form.intermediary_country" :placeholder="$t('main.text135')">
                <el-option
                  v-for="item in code_json"
                  :key="item"
                  :label="item"
                  :value="findKey(code_json, item)">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('main.text357')">
              <el-input v-model="add_form.intermediary_swift_code" type="text"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text358')">
              <el-input v-model="add_form.intermediary_address" type="text"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="add_user_dlg = false" class="cancel_btn border_set_color2">
          {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="add_dlg_save" class="confirm_btn">
          <span v-if="add_or_edit">{{$t('main.text104')}}</span>
          <span v-else>{{$t('main.text236')}}</span>
        </el-button>
      </span>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
        :visible.sync="delete_user_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <div class="log_out1">
            <img src="../../../assets/img/warning_icon.png" alt="">
        </div>
        <div class="log_out2">
          {{$t('main.text367')}}
        </div>
        <div class="log_out3">
          {{$t('main.text379')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="delete_user_dlg = false" class="cancel_btn border_set_color2">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="del_dlg_remove">{{$t('main.text369')}}</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import {withdraw_payee_list,withdraw_payee_add,withdraw_payee_edit,withdraw_payee_del} from '@/api/api';
export default {
    data() {
        return {
            checkList: [],
            add_user_dlg:false,
            name:'',
            region:'',
            delete_user_dlg:false,

            currentPage: 1,//选中的页数
            page: 1, //分页 从 1 开始
            limit: 10, //每页条数
            page_total: 0, //一共多少条
            tableData:[],
            add_form:{
              name:"",
              account_number:"",
              beneficiary_name:"",
              swift_code:"",
              address:"",

              intermediary_name:"",
              intermediary_country:"",
              intermediary_swift_code:"",
              intermediary_address:""
            },
            code_json:'',
            add_or_edit:true,//true 默认添加  false 编辑
            edit_item:{},
            del_item:{}

        }
    },
    created() {
      if(this.v_lan=='ch'){
        this.code_json=require("@/assets/phone_code/num_area_ch.json");
      }else{
        this.code_json=require("@/assets/phone_code/num_area_en.json");
      }
    },
    beforeDestroy(){
      sessionStorage.removeItem('top_title_name');
    },
    mounted() {
      sessionStorage.setItem('top_title_name',this.$t('main.text380'));
      this.get_list();
      this.checkList=[];
    },
    methods: {
      //创建一个方法，返回value值对应的key
      findKey(obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find((k) => compare(obj[k], value));
      },
      checkbox_fun(item){
        this.checkList=[];
        this.checkList=[item.name];
      },
      get_list(){
        withdraw_payee_list({
          page:this.page,
          limit:this.limit
        }).then(res=>{
          if (res.data.code==200) {
            this.tableData=res.data.data.list;
            this.page_total=res.data.data.count;
            // console.log(res.data.data);
          }
        })
      },
      current_change(v){
        // console.log(v);
        this.page=v;
        this.limit=10;
        this.get_list();
      },
      add_btn(){
        this.add_form.name="";
        this.add_form.account_number="";
        this.add_form.beneficiary_name="";
        this.add_form.swift_code="";
        this.add_form.address="";

        this.add_form.intermediary_name="";
        this.add_form.intermediary_country="";
        this.add_form.intermediary_swift_code="";
        this.add_form.intermediary_address="";

        this.add_or_edit=true;
        this.add_user_dlg=true;
      },
      edit_fun(item){
        this.add_form.name=item.name;
        this.add_form.account_number=item.account_number;
        this.add_form.beneficiary_name=item.beneficiary_name;
        this.add_form.swift_code=item.swift_code;
        this.add_form.address=item.address;

        this.add_form.intermediary_name=item.intermediary_name;
        this.add_form.intermediary_country=item.intermediary_country;
        this.add_form.intermediary_swift_code=item.intermediary_swift_code;
        this.add_form.intermediary_address=item.intermediary_address;

        this.edit_item=item;
        
        this.add_or_edit=false;
        this.add_user_dlg=true;
      },
      delete_fun(item){
        this.del_item=item;
        this.delete_user_dlg=true;
      },
      add_dlg_save(){
        if (!this.add_form.name) {
          return this.message.ismessage('error',this.$t('main.text371'));
        }
        if (!this.add_form.account_number) {
          return this.message.ismessage('error',this.$t('main.text381'));
        }
        if (!this.add_form.beneficiary_name) {
          return this.message.ismessage('error',this.$t('main.text382'));
        }
        if (!this.add_form.swift_code) {
          return this.message.ismessage('error',this.$t('main.text383'));
        }
        if (!this.add_form.address) {
          return this.message.ismessage('error',this.$t('main.text384'));
        }
        // if (!this.add_form.intermediary_name) {
        //   return this.message.ismessage('error',this.$t('main.text385'));
        // }
        // if (!this.add_form.intermediary_country) {
        //   return this.message.ismessage('error',this.$t('main.text386'));
        // }
        // if (!this.add_form.intermediary_swift_code) {
        //   return this.message.ismessage('error',this.$t('main.text387'));
        // }
        // if (!this.add_form.intermediary_address) {
        //   return this.message.ismessage('error',this.$t('main.text388'));
        // }

        if (this.add_or_edit) {
          // 添加
          withdraw_payee_add({
            name:this.add_form.name,
            address:this.add_form.address,
            account_number:this.add_form.account_number,
            beneficiary_name:this.add_form.beneficiary_name,
            swift_code:this.add_form.swift_code,
            intermediary_name:this.add_form.intermediary_name,
            intermediary_address:this.add_form.intermediary_address,
            intermediary_country:this.add_form.intermediary_country,
            intermediary_swift_code:this.add_form.intermediary_swift_code
          }).then(res=>{
            if (res.data.code==200) {
              this.page=1;
              this.limit=10;
              this.currentPage=1;
              this.get_list();
              this.add_user_dlg=false;
              this.message.ismessage('success',this.$t('main.text374'));
            }else{
              this.message.ismessage('error',res.data.msg);
            }
          })
        }else{
          // 编辑
          withdraw_payee_edit({
            id:this.edit_item.id,
            name:this.add_form.name,
            address:this.add_form.address,
            account_number:this.add_form.account_number,
            beneficiary_name:this.add_form.beneficiary_name,
            swift_code:this.add_form.swift_code,
            intermediary_name:this.add_form.intermediary_name,
            intermediary_address:this.add_form.intermediary_address,
            intermediary_country:this.add_form.intermediary_country,
            intermediary_swift_code:this.add_form.intermediary_swift_code
          }).then(res=>{
            if (res.data.code==200) {
              this.page=1;
              this.limit=10;
              this.currentPage=1;
              this.get_list();
              this.add_user_dlg=false;
              this.message.ismessage('success',this.$t('main.text375'));
            }else{
              this.message.ismessage('error',res.data.msg);
            }
          })
        }
      },
      del_dlg_remove(){
        withdraw_payee_del({
          id:this.del_item.id,
        }).then(res=>{
          if (res.data.code==200) {
            this.page=1;
            this.limit=10;
            this.currentPage=1;
            this.get_list();
            this.message.ismessage('success',this.$t('main.text376'));
            this.delete_user_dlg=false;
          }else{
            this.message.ismessage('error',res.data.msg);
          }
        })
      }

    },
}
</script>

<style scoped>
.m_m_payee_list{
    box-sizing: border-box;
    padding: 28px;
    background: #232A36;
    border-radius: 16px;
}
.list_title1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 20px;
}
.list_table{
    display: block;
    width: 100%;
}
.list_table>div{
    width: 100%;
    /* display: block; */
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.list_table>div:nth-child(odd){
    background: #2B323E;
    border-radius: 12px;
}
.list_table>div>div{
    /* min-width: 130px; */
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
}
.list_table div .td1{
    width: 25%;
}
.list_table div .td2{
    width: 25%;
    word-wrap: break-word;
}
.list_table div .td3{
    width: 25%;
}
.list_table div .td4{
    width: 25%;
}
.list_table .text_r{
    text-align: right;
}
.list_table .el-checkbox{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
}
.list_table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.list_table >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#fff;
    border-color:#fff;
    box-shadow: 0px 0px 0px 2px #39526F inset;
}
.list_table >>> .el-checkbox__inner{
    border-radius: 50%;
    background: transparent;
    width: 24px;
    height: 24px;
}
.list_table >>> .el-checkbox__inner::after{
    display: none;
}
.edit_btn{
    color: #DEB981;
    margin-right: 40px;
    cursor: pointer;
}
.delete_btn{
    color: #F35F65;
    cursor: pointer;
}
.table_btm{
    /* margin-top: 28px; */
    margin-bottom: 28px;
}
.add_btn,
.add_btn:hover,
.add_btn:focus,
.add_btn:active{
    min-width: 300px;
    height: 44px;
    color: #00C18E;
    background: transparent;
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    border-style:solid;
    border-width: 1.5px;
    border-color:#00C18E;
}
.top_text{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 28px;
}
.border_bottom{
    /* border: 1px solid #020D16; */
}
.no_data_text{
    text-align: center;
    display: inherit;
}
</style>
